import { render, staticRenderFns } from "./CardSearchNfsesServicos.vue?vue&type=template&id=61077346&"
import script from "./CardSearchNfsesServicos.vue?vue&type=script&lang=js&"
export * from "./CardSearchNfsesServicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports